<template>
  <div>

    <v-toolbar flat fixed>
      <v-toolbar-side-icon @click="$router.go(-1)"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
      <!-- <v-toolbar-title class="white--text">Transaction Forms</v-toolbar-title> -->
      <v-toolbar-title class="white--text">Select Form</v-toolbar-title>
    </v-toolbar>

    <div style="background-color:#F0F0F0;" class="hasToolbar">
      <v-list subheader v-for="(category, index) in listCategories" :key="index" style="margin-bottom:10px;padding:0">
        <v-subheader light>{{category.name}}</v-subheader>
        <v-divider></v-divider>
        <v-list-tile v-for="(item, index) in category.items" :key="index" @click="fn_openList(item.typeId)">
          <v-list-tile-content>
            <v-list-tile-title v-html="item.title"></v-list-tile-title>
          </v-list-tile-content>

          <v-list-tile-action>
            <v-icon>keyboard_arrow_right</v-icon>
          </v-list-tile-action>

        </v-list-tile>

        <v-divider v-if="listCategories.length-1 != index"></v-divider>
      </v-list> 

    </div>
  </div>
</template>

<script>
const transactionTypes = require('../../../config.js').configs.transactionTypes;

  export default{
    data(){
      return{
        "listCategories":[  
                  {
                    "name":"Sales", 
                    "items":[
                      {
                        "id":1, 
                        "title":"Order",
                        "typeId":transactionTypes.order.id
                      },
                      {
                        "id":2, 
                        "title":"Delivery Challan",
                        "typeId":transactionTypes.deliveryChallan.id
                      },
                      {
                        "id":3, 
                        "title":"Sale Invoice",
                        "typeId":transactionTypes.salesInvoice.id
                      },
                      {
                        "id":4, 
                        "title":"Sale Return",
                        "typeId":transactionTypes.salesReturn.id
                      },
                      {
                        "id":5, 
                        "title":"Estimate",
                        "typeId":transactionTypes.estimate.id
                      }
                    ]
                  },

                  {
                    "name":"Purchase", 
                    "items":[
                      {
                        "id":1, 
                        "title":"Purchase Order",
                        "typeId":transactionTypes.purchaseOrder.id
                      },
                      {
                        "id":2, 
                        "title":"Purchase Challan",
                        "typeId":transactionTypes.purchaseChallan.id
                      },
                      {
                        "id":3, 
                        "title":"Purchase Invoice",
                        "typeId":transactionTypes.purchaseInvoice.id
                      },
                      {
                        "id":4, 
                        "title":"Purchase Return",
                        "typeId":transactionTypes.purchaseReturn.id
                      },
                      {
                        "id":5, 
                        "title":"Expense",
                        "typeId":transactionTypes.expense.id
                      }
                    ]
                  },

                  // {
                  //   "name":"Acount Books", 
                  //   "items":[
                  //     {
                  //       "id":1, 
                  //       "title":"Receipt",
                  //       "typeId":transactionTypes.receipt.id
                  //     },
                  //     {
                  //       "id":2, 
                  //       "title":"Payment",
                  //       "typeId":transactionTypes.payment.id
                  //     },
                  //     {
                  //       "id":3, 
                  //       "title":"Journal",
                  //       "typeId":transactionTypes.journal.id
                  //     },
                  //     {
                  //       "id":4, 
                  //       "title":"Contra",
                  //       "typeId":transactionTypes.contra.id
                  //     },
                  //     // {
                  //     //   "id":5, 
                  //     //   "title":"Credit Note",
                  //     //   "typeId":transactionTypes.creditNote.id
                  //     // },
                  //     // {
                  //     //   "id":5, 
                  //     //   "title":"Debit Note",
                  //     //   "typeId":transactionTypes.debitNote.id
                  //     // }
                  //   ]
                  // },

                  // {
                  //   "name":"Inventory", 
                  //   "items":[
                  //     {
                  //       "id":1, 
                  //       "title":"Stock Journal",
                  //       "typeId":transactionTypes.stockJournal.id
                  //     }
                  //   ]
                  // },
                ]
      }
    },
    methods:{
      fn_openList: function(typeId){
        this.$router.push({path:"/settings/transaction/"+typeId});
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/settings/transaction/transaction_type_settings.vue